<div class="modal-header" mat-dialog-title>
    <div class="modal-header-icon">
        <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
    </div>
    <div class="modal-header-titles">
        <h2 class="modal-title">Lançar estoque</h2>
        <span class="modal-subtitle">{{ data.rotuloDocumento }}</span>
    </div>
    <div class="modal-header-close-btn-container">
        <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar" (click)="fechar()">
            <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
    </div>
</div>

<mat-dialog-content class="modal-content scroll-suave">
    @if (isLoading) {
        <app-loading-box height="56" width="100%" marginTop="0"></app-loading-box>
        <app-loading-box height="56" width="100%" marginTop="12"></app-loading-box>
    } @else {
        <p class="pvle-descricao">
            Cada linha sai do local de estoque indicado, na quantidade do pedido, com os lotes ou séries selecionados.
            Se o pedido tiver reserva de estoque, ela é consumida pela saída. Tudo ou nada: se faltar saldo para alguma
            linha, nada sai. Depois do lançamento o pedido fica em leitura; para editar, exclua o estoque pelo menu Ações.
        </p>

        @if (precisaEscolherFabricado) {
            <div class="pvle-fabricado">
                <span class="pvle-fabricado-rotulo">O pedido tem produto fabricado. O que sai do estoque?</span>
                <mat-radio-group [(ngModel)]="escolhaFabricado" (change)="aoEscolherFabricado()" [disabled]="isLancando"
                    aria-label="O que sai do estoque">
                    <mat-radio-button [value]="tipoLancamentoEstoqueFabricadoEnum.ProdutoFabricado">O produto fabricado</mat-radio-button>
                    <mat-radio-button [value]="tipoLancamentoEstoqueFabricadoEnum.Componentes">
                        Os componentes da estrutura
                    </mat-radio-button>
                </mat-radio-group>
            </div>
        }

        @if (pendenciasDoPedido.length) {
            <app-alert-card type="warning" title="O estoque do pedido não pode sair">
                <ul class="pvle-pendencias">
                    @for (pendencia of pendenciasDoPedido; track $index) {
                        <li>{{ pendencia.motivo }}</li>
                    }
                </ul>
                Troque o local das linhas ou ajuste o saldo e lance de novo.
            </app-alert-card>
        }

        @if (pendenciasForaDoDialogo.length) {
            <app-alert-card type="warning" title="Há itens com pendência">
                <ul class="pvle-pendencias">
                    @for (pendencia of pendenciasForaDoDialogo; track $index) {
                        <li>Item {{ pendencia.sequencia }} ({{ pendencia.descricao }}): {{ pendencia.motivo }}</li>
                    }
                </ul>
                Edite os itens pela tela do pedido, salve e lance de novo.
            </app-alert-card>
        }

        @if (!linhas.length && !pendenciasForaDoDialogo.length) {
            <app-alert-card type="info" title="Nada a lançar">
                Nenhum item do pedido movimenta estoque.
            </app-alert-card>
        }

        @for (item of linhas; track chave(item)) {
            <div class="pvle-linha">
                <mat-icon class="material-symbols-outlined pvle-icone" [class.pvle-icone-ok]="!motivoDaLinha(item)">
                    {{ motivoDaLinha(item) ? 'error_outline' : 'arrow_upward' }}
                </mat-icon>
                <div class="pvle-corpo">
                    <strong>{{ item.sequencia }}. {{ item.descricao }}</strong>
                    @if (item.idProdutoFabricado) {
                        <span class="pvle-detalhe">Componente de {{ item.descricaoProdutoFabricado }}</span>
                    }
                    <span class="pvle-detalhe">−{{ item.quantidade | abnt:'quantidade' }} {{ item.siglaUnidade }}</span>

                    <app-select-pesquisavel class="pvle-local" label="Local de estoque" [control]="controleLocal(item)"
                        [offlineList]="locais" idField="id" nameField="descricao" [disabled]="isLancando" subscriptSizing="dynamic"
                        placeholder="Selecione...">
                    </app-select-pesquisavel>

                    @if (item.isControlaLotes || item.isControlaSeries) {
                        <div class="pvle-lote-serie">
                            <button mat-button type="button" class="pvle-lote-serie-toggle" (click)="alternarLinha(item)"
                                [attr.aria-expanded]="linhaAberta === chave(item)">
                                <mat-icon class="material-symbols-outlined">
                                    {{ linhaAberta === chave(item) ? 'expand_less' : 'expand_more' }}
                                </mat-icon>
                                {{ item.isControlaSeries ? 'Séries' : 'Lotes' }}
                                @if (descricaoOrigem(item)) { <span class="pvle-origem">· {{ descricaoOrigem(item) }}</span> }
                            </button>
                            @if (linhaAberta !== chave(item)) {
                                <span class="pvle-detalhe">
                                    @if (item.isControlaSeries) {
                                        {{ descricaoSeries(item) || 'Nenhuma série selecionada' }}
                                    } @else {
                                        @for (lote of item.lotes; track $index; let ultimo = $last) {
                                            {{ lote.codigoLote }} ({{ lote.quantidade | abnt:'quantidade' }}){{ ultimo ? '' : ', ' }}
                                        } @empty {
                                            Nenhum lote selecionado
                                        }
                                    }
                                </span>
                            } @else {
                                <app-estoque-lote-serie-inline
                                    [tipo]="item.isControlaSeries ? 'serie' : 'lote'"
                                    modo="selecionar"
                                    [quantidadeAlvo]="item.quantidade"
                                    [isFracionada]="item.isUnidadeMedidaFracionada"
                                    [contexto]="nomeLocal(item)"
                                    [idProduto]="item.idProduto"
                                    [idLocalizacaoEstoque]="item.idLocalizacaoEstoque"
                                    [isSomenteLeitura]="isLancando"
                                    [disponiveis]="painel(item).disponiveis"
                                    [itens]="painel(item).itens"
                                    [aberto]="true"
                                    (itensChange)="aoAlterarSelecao(item, $any($event))">
                                </app-estoque-lote-serie-inline>
                            }
                        </div>
                    }

                    @if (motivoDaLinha(item); as motivo) {
                        <span class="pvle-motivo">{{ motivo }}</span>
                    }
                </div>
            </div>
        }
    }
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
    <button mat-stroked-button type="button" class="btn-secondary" [disabled]="isLancando" (click)="fechar()">Cancelar</button>
    <span [matTooltip]="tooltipLancar" [matTooltipDisabled]="!tooltipLancar">
        <button mat-flat-button type="button" class="btn-primary btn-spinner" [class.btn-loading]="isLancando"
            [disabled]="!podeLancar || isLancando" [attr.aria-label]="isLancando ? 'Lançando estoque' : 'Lançar estoque'"
            (click)="confirmar()">
            <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
            Lançar estoque
            @if (isLancando) { <mat-spinner diameter="20"></mat-spinner> }
        </button>
    </span>
</mat-dialog-actions>
